import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccountingFirms = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(3.5 2)",
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("path", { d: "M14.43,6.63c0,.41-.33.74-.74.74H3.32c-.41,0-.74-.33-.74-.74v-3.66c0-.41.33-.74.74-.74h10.37c.41,0,.74.33.74.74v3.66ZM14.43,16.3c0,.82-.66,1.48-1.48,1.48s-1.48-.66-1.48-1.48v-4.44c0-.82.66-1.48,1.48-1.48s1.48.66,1.48,1.48v4.44ZM8.5,13.33c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48,1.48.66,1.48,1.48-.66,1.48-1.48,1.48M8.5,17.78c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48,1.48.66,1.48,1.48-.66,1.48-1.48,1.48M4.06,13.33c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48,1.48.66,1.48,1.48-.66,1.48-1.48,1.48M4.06,17.78c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48,1.48.66,1.48,1.48-.66,1.48-1.48,1.48M15.91,0H1.09C.68,0,.35.33.35.74v18.52c0,.41.33.74.74.74h14.81c.41,0,.74-.33.74-.74V.74c0-.41-.33-.74-.74-.74" })
	})
});
export default SvgAccountingFirms;
